import { SETTINGS } from '../constants'
import emptyTemplate from './empty-template'
import {
  footerSystemAnimateUnmount,
  footerSystemTimeDelayUnmount,
} from './helpers/helpers'
import setContent from './setContent'

export function loadPageData(data) {
  const self = this
  self.pageData = data

  self.options.contentSeo =
    data[SETTINGS.SEO] && data[SETTINGS.SEO].value !== 'false'
      ? JSON.parse(data[SETTINGS.SEO].value)
      : self.options.contentSeo

  self.options.contentCss =
    data[SETTINGS.CSS] && data[SETTINGS.CSS].value !== 'false'
      ? JSON.parse(data[SETTINGS.CSS].value)
      : self.options.contentCss

  self.options.contentTracking.tracking =
    data[SETTINGS.TRACKING] && data[SETTINGS.TRACKING].value !== 'false'
      ? JSON.parse(data[SETTINGS.TRACKING].value)
      : self.options.contentTracking.tracking

  self.options.contentHTMLs.htmls =
    data[SETTINGS.BODY_CUSTOM_HTML] &&
    data[SETTINGS.BODY_CUSTOM_HTML].value !== 'false'
      ? JSON.parse(data[SETTINGS.BODY_CUSTOM_HTML].value)
      : self.options.contentHTMLs.htmls

  self.options.integrations =
    data[SETTINGS.INTEGRATION] && data[SETTINGS.INTEGRATION].value !== 'false'
      ? JSON.parse(data[SETTINGS.INTEGRATION].value)
      : self.options.integrations

  self.options.contentConversions.conversions =
    data[SETTINGS.CONVERSIONS] && data[SETTINGS.CONVERSIONS].value !== 'false'
      ? JSON.parse(data[SETTINGS.CONVERSIONS].value)
      : self.options.contentConversions.conversions

  self.options.contentPopup =
    data[SETTINGS.POPUP] && data[SETTINGS.POPUP].value !== 'false'
      ? JSON.parse(data[SETTINGS.POPUP].value)
      : self.options.contentPopup

  if (data[SETTINGS.SCRIPTS] && data[SETTINGS.SCRIPTS].value !== 'false') {
    const parse = JSON.parse(data[SETTINGS.SCRIPTS].value)
    const tempScript = {}

    parse.forEach((el) => {
      tempScript[el.position] = el
    })

    // Maximize compatibility: If not have footer_system, push it (default).
    if (!tempScript.footer_system) {
      tempScript.footer_system = self.options.contentScripts.footer_system
    } else {
      // If have, push default content (will be populated at elements inits and timeDelayUnmount)
      tempScript.footer_system.content =
        self.options.contentScripts.footer_system.content
    }

    tempScript.footer_system.content.timeDelayArr =
      footerSystemTimeDelayUnmount(tempScript.footer_system.script)

    tempScript.footer_system.content.animateArr = footerSystemAnimateUnmount(
      tempScript.footer_system.script
    )

    // Maximize compatibility: If not have header_system, push it (default).
    if (!tempScript.header_system) {
      tempScript.header_system = self.options.contentScripts.header_system
    } else if (tempScript.header_system.content) {
      const {
        content: { background = self.options.globalStyle.background }, // if not set, push it (default).
      } = tempScript.header_system

      const style = {
        backgroundColor: background.color || '#ffffff00',
        // backgroundImage: background.gradient.style ? bgImg : `url(${background.img.src})`,
        backgroundImage:
          background.img && background.img.src
            ? `url(${background.img.src})`
            : 'none',
        backgroundPosition:
          (background.img && background.img.position) ||
          self.options.globalStyle.background.img.position,
        backgroundRepeat:
          (background.img && background.img.repeat) ||
          self.options.globalStyle.background.img.repeat,
        backgroundSize:
          (background.img && background.img.size) ||
          self.options.globalStyle.background.img.size,
      }
      self.options.globalStyle.background = background

      // self.iframeBody.parent().css(style)
      self.iframeBody.css(style)

      //= =================================================================
      // Maximize compatibility: For legacy pages that header_system.content don't have new props

      if (!tempScript.header_system.content.timeDelayStyle) {
        tempScript.header_system.content.timeDelayStyle =
          self.options.contentScripts.header_system.content.timeDelayStyle
      }
      if (!tempScript.header_system.content.pixelLeadOnSubmit) {
        tempScript.header_system.content.pixelLeadOnSubmit = {
          ...self.options.contentScripts.header_system.content
            .pixelLeadOnSubmit,
        }
      }
    } else {
      // Maximize compatibility: May have pages with header_sytem but without content property setted.
      tempScript.header_system.content = {
        ...self.options.contentScripts.header_system.content,
      }
      tempScript.header_system.content.background = JSON.parse(
        JSON.stringify(self.options.globalStyle.background)
      ) // avoid copy nested objects by reference
      // console.log(tempScript.header_system)
    }

    self.options.contentScripts = tempScript
  }

  if (
    data[SETTINGS.URL] &&
    data[SETTINGS.URL].value !== 'false' &&
    data[SETTINGS.BODY].value
  ) {
    self.options.previewURL = data[SETTINGS.URL].value
  }

  window.addEventListener('new-user-snippet-created', ({ detail }) => {
    const key = `@mf/templates-${new Date().getTime()}`
    localStorage.setItem(key, detail)
    const templateList = JSON.parse(
      localStorage.getItem('@mf/templates') ?? '[]'
    )
    templateList.push(key)
    localStorage.setItem('@mf/templates', JSON.stringify(templateList))
  })

  // data[SETTINGS.BODY].value &&
  setContent.call(
    self,
    data[SETTINGS.BODY].value || emptyTemplate,
    false,
    false
  )
}
